/**
 * F010: ACC Checklist Page
 *
 * Standalone page at /compliance/acc that renders the AccChecklistPanel.
 * Supports ?year=YYYY query param to show a specific compliance year.
 *
 * Route: /compliance/acc (registered in App.tsx by F010)
 */

import { useSearch } from "wouter";
import { AccChecklistPanel } from "@/components/panels/acc-checklist-panel";
import { ComplianceLayout } from "./compliance-layout";

function AccContent() {
  const search = useSearch();
  const params = new URLSearchParams(search ?? "");
  const yearParam = params.get("year");
  const year = yearParam ? parseInt(yearParam, 10) : undefined;

  return (
    <div className="mx-auto max-w-5xl">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Annual Compliance Certificate</h1>
      </div>

      <AccChecklistPanel year={year} />
    </div>
  );
}

export default function AccPage() {
  return (
    <ComplianceLayout>
      <AccContent />
    </ComplianceLayout>
  );
}
